<mdi-topbar [isHome]="false"></mdi-topbar>
<div class="container-fluid" style="margin-top: 75px; height: 80%;  width: 100%;">
    <div class="flex-row row  stdTheme" style="height: 45px; padding: 0px; margin-left: 0px; margin-right: 0px;">
        <div class="col-1 top-sidenav" style ="text-align: start!important">
            <button mat-icon-button class="buttonTheme"  (click)="refresh()" 
                    style="margin-left: 10px;margin-right: 10px;">
                <span class="fas fa-redo" style="font-size: 20px" ></span>
            </button>
        </div>
        <div class="col top-sidenav" style ="text-align: center!important">
          <span style="font-size:large"><strong>{{ 'works-stock-movements' | translate }}</strong></span>
        </div>
    </div>
    <div *ngIf="initializeScreen" class="flex-row row  stdTheme w-100" style="padding: 0px; margin-left: 0px; margin-right: 0px;">
            <!--dynamicHeight class="mat-tab-fill-height" -->
        <mat-tab-group class="w-100" mat-align-tabs="start" (selectedTabChange)="selectedTabChange('deliveries', $event)" >
            <mat-tab  style="height: 100%!important;max-height: 100%!important;">
                <ng-template mat-tab-label>
                    <span (click)="currentTabSelected('deliveriesNew')"><b>{{ labelsTabs[0] | translate }}</b></span>
                </ng-template>
                <ng-template matTabContent>
                    <ng-container *ngTemplateOutlet="deliveriesTemplate; context: { status: 'new' }"></ng-container>
                </ng-template>
            </mat-tab>
            <mat-tab  style="height: 100%!important;max-height: 100%!important;">
                <ng-template mat-tab-label>
                    <span (click)="currentTabSelected('deliveriesWaiting')"><b>{{ labelsTabs[1] | translate }}</b></span>
                </ng-template>
                <ng-template matTabContent>
                    <ng-container *ngTemplateOutlet="deliveriesTemplate; context: { status: 'waiting' }"></ng-container>
                </ng-template>
            </mat-tab>
            <mat-tab  style="height: 100%!important;max-height: 100%!important;">
                <ng-template mat-tab-label>
                    <span (click)="currentTabSelected('deliveriesArchives')"><b>{{ labelsTabs[2] | translate }}</b></span>
                </ng-template>
                <ng-template matTabContent>
                    <ng-container *ngTemplateOutlet="deliveriesTemplate; context: { status: 'history' }"></ng-container>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>
<ng-template #deliveriesTemplate >
    <!--   https://stackblitz.com/angular/ynbnyenqnvx?file=src%2Fapp%2Fsidenav-open-close-example.ts -->
    <div class="container-fluid stdTheme " style="height: 700px;max-height: 700px;;min-height: 700px; overflow:hidden !important" >
         <div *ngIf="isLoadingData && !displayErrorMsg" class="spinner-container  stdTheme flex-row row h-50 align-items-center" >
            <div class="col-12 d-flex justify-content-center" style="padding: 0px; margin-left: 0px; margin-right: 0px;">
                <mat-spinner diameter="40" strokeWidth="5"></mat-spinner>
            </div>
            <div  class="col-12 d-flex justify-content-center" style="margin-left: 0px; margin-right: 0px;">
                <span class="loading-text">{{ 'loading data' | translate }}<span class="dots"></span></span>
            </div>
        </div>
        <div *ngIf="!isLoadingData && displayErrorMsg" class="stdTheme flex-row row h-50 align-items-center" >
            <div  class="col-12 d-flex justify-content-center" style="margin-left: 0px; margin-right: 0px;">
                <span class="loading-text">{{errorMsg}}</span>
            </div>
        </div>
        <div *ngIf="!isLoadingData && !displayErrorMsg" class="flex-row row w-100 h-100" style="margin-left: 0px; margin-right: 0px;">
             <div class="col-5">
                <div class="flex-row row rowTitle w-100" style="margin-left: 0px; margin-right: 0px;">
                    <div class="col-2 d-flex justify-content-center"><b>{{'workRef' | translate}}</b></div>
                    <div class="col-4 d-flex justify-content-center"><b>{{'workObject' | translate}}</b></div>
                    <div class="col-2 d-flex justify-content-center"><b>{{'workStatut' | translate}}</b></div>
                    <div class="col-3 d-flex justify-content-center"><b>{{'dateOperation' | translate}}</b></div>
                    <div class="col-1 d-flex justify-content-center"></div>
                </div>
                <div class="lineWks" style="margin-top: 5px;"></div>
                <div *ngIf="rowsWorks.length > 0" style="height: 650px;max-height: 650px;overflow-y: auto ">
                    <div class="stdTheme" *ngFor="let rowCur of rowsWorks; let i = index"  >
                        <div class="flex-row row rowlist w-100" style="margin-left: 0px; margin-right: 0px;"
                                [ngClass]="{'rowworksSelected': rowCur.isSelected,'rowWorkOdd':rowCur.odd,'rowWorkEven':!rowCur.odd}"
                                 >
                            <div class="col-2 d-flex justify-content-center" style="padding-left: 0px;padding-right: 0px;">
                                <span *ngIf="tabSelected === 1">
                                    <button [disabled]="!rowCur.isArchivable" mat-icon-button (click)="archiveRow(i)">
                                        <i class="fa fa-archive" style="font-size: 15px"></i>
                                    </button> 
                                </span>
                                <span *ngIf="tabSelected === 2">
                                    <button  mat-icon-button (click)="activeRow(i)">
                                        <i class="fas fa-toggle-on" style="font-size: 15px"></i>
                                    </button> 
                                </span>
                                <span (click)="setClickedWork(i)">{{rowCur.workRef }}</span>
                            </div>
                            <div class="col-4 d-flex justify-content-start">{{rowCur.workLabel }}</div>
                            <div class="col-2 d-flex justify-content-center">{{rowCur.workStatut | translate }}</div>
                            <div class="col-3 d-flex justify-content-center" style="padding-left: 0px;padding-right: 0px;">{{rowCur.dateOperation | translate }}</div>
                            <div class="col-1">
                                <button  mat-icon-button (click)="rowCur.isCollapsed = !rowCur.isCollapsed; collapsedOther(i, rowCur.isCollapsed) ">
                                    <span *ngIf="rowCur.isCollapsed"  >
                                        <i class="fa fa-chevron-down" style="font-size: 15px"></i>
                                    </span>
                                    <span *ngIf="!rowCur.isCollapsed" >
                                        <i class="fa fa-chevron-up" style="font-size: 15px"></i>
                                    </span>
                                </button> 
                            </div>
                        </div>
                        <div [ngbCollapse]="rowCur.isCollapsed">
                            <fieldset class="rowWork-border" style="margin-bottom: 10px">
                                <div class="flex-row row rowlist w-100"  >
                                    <!--<div class="col-2 d-flex justify-content-start">{{'ownerName' | translate }}</div>-->
                                    <div class="col-4 d-flex justify-content-start" (click)="copyWorkIdToClipBoard(i)" >{{rowCur.workRef }} {{rowCur.ownerDesign }}</div>
                                </div>
                                
                                <div class="stdTheme" *ngFor="let taskCur of rowCur.workTasksList; let i2 = index"  >
                                    <div class="flex-row row w-100" style="display: flex; align-items: center;">
                                        <div class="col-1 d-flex justify-content-end"><i class="fa fa-arrow-right" aria-hidden="true"></i></div>
                                        <!--<div class="col-2 d-flex justify-content-start">{{'jobDesc' | translate }}</div>-->
                                        <div class="col-9 d-flex justify-content-start">{{taskCur.workTask.taskrefLabel}}</div>
                                    </div>
                                
                                    <div class="stdTheme" *ngFor="let equipCur of taskCur.taskEquip; let i3 = index"  >
                                        <div class="flex-row row w-100" style="display: flex; align-items: center;height: 25px">
                                            <div class="col-2 d-flex justify-content-end" style="height: 25px">
                                                <i class="fa fa-circle" style="font-size: 8px;height: 25px" aria-hidden="true"></i>
                                            </div>
                                            <div class="col-10 d-flex justify-content-start" style="display: flex; align-items: center;height: 25px">
                                                {{equipCur.equipType | translate }} / {{equipCur.equipName}}
                                                <span *ngIf="equipCur.equipModel !== undefined && equipCur.equipModel !== '' && equipCur.equipModel !== null" >
                                                    &nbsp;/ {{equipCur.equipModel}}
                                                </span>
                                                <span *ngIf="equipCur.equipImmat !== undefined && equipCur.equipImmat !== '' && equipCur.equipImmat !== null" >
                                                    &nbsp;/ Immat : {{equipCur.equipImmat}}
                                                </span>
                                                <span *ngIf="equipCur.equipSN !== undefined && equipCur.equipSN !== '' && equipCur.equipSN !== null " >
                                                    &nbsp;/ SN : {{equipCur.equipSN}}
                                                </span>
                                            </div>
                                        </div>   
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                        <div class="lineWks" style="margin-top: 5px;"></div>
                    </div>
                </div>
            </div>
            <!--<div style="border-left: 1px solid #df0c0c; height: auto; margin: 0 10px;"></div>-->
            <div class="verticalWks"></div>
            <div class="col h-100" *ngIf="displayParts">
                <mdi-parts-supplies-movement
                    (dataOut)="partSuppliesMovement($event)"
                    [idxWorkToDisplay]="idxToDisplay"
                    [partsStock]="rowsWorks[idxToDisplay].partsStock" 
                    [callFrom]="'works-stock-movements'"
                    [readStock]="readStock"
                    [readOnly]="readOnly"
                    [wksEntity]="wksEntity"
                    [workRef]="rowsWorks[idxToDisplay].work.workRef"
                    [workId]="rowsWorks[idxToDisplay].workId">
                </mdi-parts-supplies-movement>
            </div>
        </div>
    </div>
</ng-template>
